import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { Header } from '@app/navigation/header';
import { Body, Container, Body5, H5, Page } from '@ui';
import { BackArrowButton } from '@ui/buttons';
import { ROUTES } from '@constants/routes';
import { AI_TOOLS } from '@constants';
import { useCurrentUserToolsAvailable } from '@hooks/user/useCurrentUser';
import { PasteSpecForm } from '@features/scoreSpecCreate/PasteSpecForm';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const CREATE_SCORE_SPEC_HEADING_ID = 'create-score-spec-heading';

// The third score-spec mode, and the thinnest: one textarea holding the request body.
//
// Same `score_spec_admin` grant as the other two, enforced here as well as on the server because the
// route is reachable by direct URL. What it creates is a draft, which runs nothing and can be deleted
// outright.
export const CreateScoreSpec = () => {
  const navigate = useNavigate();
  const tools = useCurrentUserToolsAvailable();

  React.useEffect(() => {
    if (tools && tools.length > 0 && !tools.includes(AI_TOOLS.SCORE_SPEC_ADMIN)) {
      navigate(ROUTES.home);
    }
  }, [tools, navigate]);

  React.useEffect(() => {
    document.getElementById(CREATE_SCORE_SPEC_HEADING_ID)?.focus();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width="840px">
          <BackArrowButton onClick={() => navigate(ROUTES.home)} aria-label="Back to home" />
          <Container top={48}>
            <H5 id={CREATE_SCORE_SPEC_HEADING_ID} tabIndex={-1}>
              Create a Score Spec
            </H5>
            <Container top={8}>
              <Body5 isLowContrast>
                Paste a whole spec definition. It is sent exactly as typed — the only things checked here are that it is
                there and that it parses.
              </Body5>
            </Container>
            <Container top={24}>
              <PasteSpecForm />
            </Container>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
};

export default CreateScoreSpec;
